/**
 * Get styling from rules per geometry type
 * @param  {Rule[]} rules [description]
 * @return {GeometryStyles}
 */
function getGeometryStyles(rules) {
    const result = {
        polygon: [],
        line: [],
        point: [],
        text: [],
    };
    for (let i = 0; i < rules.length; i += 1) {
        if (rules[i].polygonsymbolizer) {
            let polygonSymbolizer = rules[i].polygonsymbolizer;

            if (rules[i].classificationIdx) {
                polygonSymbolizer.zIndex = -rules[i].classificationIdx;
            }

            result.polygon.push(polygonSymbolizer);
        }
        if (rules[i].linesymbolizer && rules[i].linesymbolizer) {
            let lineSymbolizer = rules[i].linesymbolizer;

            if (rules[i].classificationIdx) {
                lineSymbolizer.zIndex = -rules[i].classificationIdx;
            }

            result.line.push(lineSymbolizer);
        }
        if (rules[i].pointsymbolizer) {
            let pointSymbolizer = rules[i].pointsymbolizer;

            if (rules[i].classificationIdx) {
                pointSymbolizer.zIndex = -rules[i].classificationIdx;
            }

            result.point.push(pointSymbolizer);
        }
        if (rules[i].textsymbolizer) {
            let textSymbolizer = rules[i].textsymbolizer;

            if (rules[i].classificationIdx) {
                textSymbolizer.zIndex = -rules[i].classificationIdx;
            }

            result.text.push(textSymbolizer);
        }
    }
    return result;
}

export default getGeometryStyles;

/**
 * @typedef GeometryStyles
 * @name GeometryStyles
 * @description contains for each geometry type the symbolizer from an array of rules
 * @property {PolygonSymbolizer[]} polygon polygonsymbolizers
 * @property {LineSymbolizer[]} line linesymbolizers
 * @property {PointSymbolizer[]} point pointsymbolizers, same as graphic prop from PointSymbolizer
 */
